import script from "./ProfileSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSignup.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSignup.vue?vue&type=style&index=0&id=1fe67610&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe67610"]])

export default __exports__